import { render } from "./Wiggle.vue?vue&type=template&id=63bebba8"
const script = {}

import "./Wiggle.vue?vue&type=style&index=0&id=63bebba8&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__